// @ts-nocheck
import {
  CFG,
  SPELLS,
} from "./data";
import {
  clamp,
  TAU,
} from "./util";
import {
  healPodFromWire,
  touchBossCast,
} from "./sprites";
import {
  Player,
} from "./entities";
import {
  Game,
} from "./engine";
import {
  Sound,
} from "./audio";

/* -------- WASM spell preview (real sim → same draw path as in-match) -------- */
export function applyPreviewSnapTo(host, msg) {
  host.platformRadius = msg.pr ?? host.maxRadius ?? 950;
  const now = host.nowS;
  host.players = [];
  host.playerById = {};
  for (const w of msg.p || []) {
    const p = new Player(w.c != null ? w.c : w.id, false);
    p.id = w.id;
    p.name = p.colorName;
    host.players.push(p);
    host.playerById[w.id] = p;
    p.x = w.x; p.y = w.y;
    p.facing = w.a;
    p.aim = w.am != null ? w.am : w.a;
    p.hp = w.hp;
    p.alive = w.al;
    p.falling = w.fl;
    p.fallT = w.ft || 0;
    p.shieldT = w.sh ? 1 : 0;
    p.absorbT = w.ba ? 1 : 0;
    p.reflectT = w.rf ? 1 : 0;
    p.outside = !!w.out;
    p.invisT = w.iv ? 1 : 0;
    p.root = w.rt ? 1 : 0;
    p.silence = w.si ? 1 : 0;
    p.freeze = w.fz ? 1 : 0;
    p.slowT = w.sl ? 1 : 0;
    p.rushT = w.ru ? 1 : 0;
    p.stun = w.st ? 1 : 0;
    p.burnT = w.bn ? 1 : 0;
    p.hemorrhageT = w.hm ? 1 : 0;
    p.exhaustionT = w.ex ? 1 : 0;
    p.channelSpell = w.cs || "";
    p.dashSpell = w.ds || "";
    p.boss = w.bs || "";
    p.enraged = !!w.rg;
    p.tetherBy = (w.te != null && w.te >= 0) ? host.playerById[w.te] : null;
    p.channelProg = w.cp || 0;
    p.castPose = w.qp || 0;
    if (p.castPose > 0 && p.boss) touchBossCast(p.boss);
    if (w.tm != null) p.team = w.tm;
  }
  host.decoys = (msg.dc || []).map(d => ({
    id: d.id,
    ownerId: d.o,
    index: d.c != null ? d.c : 0,
    x: d.x, y: d.y,
    facing: d.a,
    hp: d.hp,
    radius: CFG.playerRadius,
  }));
  host.projectiles = [];
  for (const b of msg.pj || []) {
    const sp = SPELLS[b.s] || { radius: 8, color: "#fff" };
    const vx = b.vx || 0, vy = b.vy || 0;
    const ang = vx !== 0 || vy !== 0 ? Math.atan2(vy, vx) : 0;
    host.projectiles.push({
      x: b.x, y: b.y, vx, vy,
      radius: b.r || sp.radius, color: sp.color, spellId: b.s, prog: b.pg || 0, ang,
      ownerId: b.o != null ? b.o : (sp.fall ? 0 : null),
    });
  }
  host.mines = (msg.mn || []).map(m => ({ x: m.x, y: m.y, arm: m.a ? 0 : 1, pulse: now }));
  const prevSg = host.sigils || [];
  host.sigils = (msg.sg || []).map(g => {
    const old = prevSg.find(p => g.s === p.spellId && Math.hypot(p.x - g.x, p.y - g.y) < 4);
    const arm = g.ar != null ? g.ar : (g.a ? 0 : 1);
    return {
      x: g.x, y: g.y, r: g.r, arm, life: g.l, spellId: g.s, pulse: now,
      fillStars: old?.fillStars || null,
    };
  });
  host.healpods = (msg.hp || []).map(h => healPodFromWire(h, now));
  const prevBz = host._prevBlizzards || [];
  host.blizzards = (msg.bz || []).map((b, i) => {
    const old = prevBz[i] || prevBz.find(p => Math.abs(p.x - b.x) < 4 && Math.abs(p.y - b.y) < 4);
    const meteorShower = !!b.ms;
    const keepFX = old && host.blizzardFXContinues(old, b);
    return {
      x: b.x, y: b.y, r: b.r, life: b.l, meteorShower, ownerId: b.o ?? 0, pulse: now,
      shards: keepFX ? (old.shards || []) : [],
      windParts: keepFX ? (old.windParts || []) : [],
      _spawnAcc: keepFX ? (old._spawnAcc || 0) : 0,
      _windAcc: keepFX ? (old._windAcc || 0) : 0,
    };
  });
  host._prevBlizzards = host.blizzards;
  const prevFw = host._prevFirewalls || [];
  host.firewalls = (msg.fw || []).map((w, i) => {
    const old = prevFw[i] || prevFw.find(p => Math.abs(p.x - w.x) < 4 && Math.abs(p.y - w.y) < 4);
    return {
      x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l,
      pulse: now,
      born: old?.born ?? now,
      emberParts: old?.emberParts || [],
      _emberAcc: old?._emberAcc || 0,
    };
  });
  host._prevFirewalls = host.firewalls;
  const prevIw = host._prevIcewalls || [];
  host.icewalls = (msg.iw || []).map((w, i) => {
    const old = prevIw[i] || prevIw.find(p => Math.abs(p.x - w.x) < 4 && Math.abs(p.y - w.y) < 4);
    return {
      x: w.x, y: w.y, dx: w.dx, dy: w.dy, hx: w.hx, hy: w.hy, life: w.l,
      pulse: now,
      born: old?.born ?? now,
      _shardAcc: old?._shardAcc || 0,
    };
  });
  host._prevIcewalls = host.icewalls;
  const prevHr = host._prevHellRips || host.hellrips || [];
  host.hellrips = (msg.hr || []).map((h, i) => {
    const old = prevHr[i] || prevHr.find(p => Math.abs(p.x - h.x) < 4 && Math.abs(p.y - h.y) < 4);
    return {
      x: h.x, y: h.y, r: h.r, rot: h.rt, arm: h.ar || 0, life: h.l,
      pulse: now,
      born: old?.born ?? now,
      fillStars: old?.fillStars || null,
      emberParts: old?.emberParts || [],
      _emberAcc: old?._emberAcc || 0,
      _ringEmberAcc: old?._ringEmberAcc || 0,
    };
  });
}

export function buildPreviewHost(game, ctx, w, h, msg) {
  const viewR = 210;
  const t = msg.time != null ? msg.time : 0;
  const host = Object.create(Game.prototype);
  Object.assign(host, {
    ctx,
    W: w, H: h, cx: w / 2, cy: h / 2,
    scale: (Math.min(w, h) / 2) / viewR,
    // Preview is flat top-down (uniform scale, no oblique squash), so scaleY === scale.
    // This keeps upright() a no-op here instead of dividing by an undefined scaleY (NaN).
    scaleY: (Math.min(w, h) / 2) / viewR,
    ax: 0, ay: 0,
    camX: msg.camX ?? 0, camY: msg.camY ?? 0,
    platformRadius: msg.pr ?? game.maxRadius ?? 950,
    maxRadius: game.maxRadius || 950,
    nowS: t, now: t * 1000,
    state: "playing",
    myId: msg.me != null ? msg.me : -1,
    players: [], playerById: {},
    projectiles: [], mines: [], sigils: [], healpods: [], blizzards: [], firewalls: [], icewalls: [], hellrips: [],
    particles: [], shockwaves: [], beams: [], dmgPopups: [], decoys: [], pillars: [],
    meteorCraters: [], floorBurns: [], meteorNukeClouds: [], meteorNukeSwamps: [], meteorNukeFuses: [],
    chargeStamps: [], armPops: [], spellSpritePops: [],
    sprites: game.sprites,
    _gradCache: game._gradCache,
    spriteTrails: [],
    _trailLastPos: {},
    _prevBlizzards: null, _prevFirewalls: null, _prevIcewalls: null, _prevHellRips: null,
    human() { return this.playerById[this.myId] || null; },
  });
  return host;
}

// Spell-preview backdrop: flat grey fill in screen space (full canvas). The WASM
// sim pans the camera, so we must not draw the real world-anchored platform here.
function drawPreviewBackdrop(ctx, w, h) {
  const cx = w / 2, cy = h / 2;
  const r = Math.hypot(w, h) * 0.55;
  const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
  g.addColorStop(0, "#4a455f");
  g.addColorStop(1, "#2e2a40");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, w, h);
}

// Lightweight platform disc for learn-to-play previews (void demo, etc.).
function drawPreviewPlatform(ctx, host) {
  const r = host.platformRadius;
  if (!(r > 2)) return;
  const t = host.nowS || 0;
  const glow = 0.5 + 0.5 * Math.sin(t * 2);
  ctx.save();
  ctx.shadowColor = `rgba(255,90,40,${0.45 + 0.25 * glow})`;
  ctx.shadowBlur = 18 + 6 * glow;
  const g = ctx.createRadialGradient(0, -r * 0.2, r * 0.1, 0, 0, r);
  g.addColorStop(0, "#54506e");
  g.addColorStop(0.7, "#363250");
  g.addColorStop(1, "#211d38");
  ctx.fillStyle = g;
  ctx.beginPath();
  ctx.arc(0, 0, r, 0, TAU);
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.lineWidth = 3;
  ctx.strokeStyle = `rgba(255,120,50,${0.65 + 0.3 * glow})`;
  ctx.beginPath();
  ctx.arc(0, 0, r - 1, 0, TAU);
  ctx.stroke();
  ctx.restore();
}

Game.prototype.renderSimPreview = function(ctx, w, h, msg, dt, carry, opts) {
  const lite = !!(opts && opts.lite);
  const step = dt != null ? clamp(dt, 0.001, 0.05) : 1 / 60;
  const host = buildPreviewHost(this, ctx, w, h, msg);
  if (carry) {
    host._prevBlizzards = carry.blizzards;
    host._prevFirewalls = carry.firewalls;
    host._prevIcewalls = carry.icewalls;
    host._prevHellRips = carry.hellrips;
    host.spriteTrails = carry.spriteTrails || [];
    host._trailLastPos = carry._trailLastPos || {};
    if (!lite) {
      host.particles = carry.particles || [];
      host.shockwaves = carry.shockwaves || [];
      host.beams = carry.beams || [];
      host.armPops = carry.armPops || [];
      host.spellSpritePops = carry.spellSpritePops || [];
      host.dmgPopups = carry.dmgPopups || [];
      host.meteorCraters = carry.meteorCraters || [];
      host.floorBurns = carry.floorBurns || [];
      host.meteorNukeClouds = carry.meteorNukeClouds || [];
      host.meteorNukeSwamps = carry.meteorNukeSwamps || [];
      host.meteorNukeFuses = carry.meteorNukeFuses || [];
    }
  }
  const prevFw = host._prevFirewalls || [];
  const prevHr = host._prevHellRips || [];
  applyPreviewSnapTo(host, msg);
  const wasBt = !!(carry && carry._btActive);
  const wasOwner = !!(carry && carry._btOwner);
  const btActive = !!msg.bt;
  const btOwnerId = btActive ? (msg.bto != null ? msg.bto : 0) : null;
  const amOwner = btActive && btOwnerId === host.myId;
  if (!lite) {
    if (btActive && !wasBt) Sound.bulletTimeStart(amOwner);
    if (wasBt && !btActive) Sound.bulletTimeEnd(wasOwner);
    Sound.updateBulletTime(btActive, amOwner);
  }
  host._bulletTimeActive = btActive;
  host._bulletTimeOwnerId = btOwnerId;
  host._bulletTimeOwner = amOwner;
  if (carry) {
    carry._btActive = btActive;
    carry._btOwner = amOwner;
  }
  if (!lite) {
    host.syncFirewallLoopAudio(prevFw, host.firewalls);
    host.syncHellRipLoopAudio(prevHr, host.hellrips);
    for (const f of msg.fx || []) host.playFX(f);
    host.updateBlizzardShards(step);
    host.updateBlizzardWind(step);
    host.updateFireWallEmbers(step);
    host.updateIceWallCollapse(step);
    host.updateHellRipEmbers(step);
    host.updateFloorBurns(step);
    host.updateMeteorNukeFuses(step);
    host.updateMeteorNukeSwamps(step);
    host.updateMeteorNukeClouds(step);
    host.updateParticles(step);
    host.updateArmPops(step);
    host.updateSpellSpritePops(step);
  }
  ctx.fillStyle = "#05060d";
  ctx.fillRect(0, 0, w, h);
  const showPlatform = !!(opts && opts.showPlatform);
  if (lite) {
    ctx.fillStyle = showPlatform ? "#0a0812" : "#3a3550";
    ctx.fillRect(0, 0, w, h);
  } else {
    drawPreviewBackdrop(ctx, w, h);
  }
  ctx.save();
  ctx.translate(host.cx, host.cy);
  ctx.scale(host.scale, host.scale);
  ctx.translate(-host.camX, -host.camY);
  if (showPlatform) drawPreviewPlatform(ctx, host);
  host.drawFloorBurns?.();
  host.drawMeteorNukeUmbra();
  host.drawMeteorNukeFuses();
  host.drawSigils();
  host.drawHealPods();
  if (!lite) host.drawArmPops();
  if (!lite) host.drawSpellSpritePops("behind");
  host.drawBlizzards();
  host.drawHellRips();
  host.drawFireWalls();
  host.drawIceWalls();
  host.drawMines();
  host.updateSpriteTrails(step);
  for (const t of (host.spriteTrails || [])) {
    if (t.mode === "bulletTimeCatchUp") continue;
    host.drawSpriteTrailGhost(t);
  }
  host.drawProjectiles();
  if (!lite) {
    host.drawBlizzardRain();
    host.drawParticles();
    host.drawMeteorNukeSwamps();
    host.drawMeteorNukeClouds();
    host.drawBeams();
    host.drawShockwaves();
  }
  host.drawPlayers();
  if (host.drawIceWallMasses) host.drawIceWallMasses();
  if (!lite) host.drawSpellSpritePops("front");
  host.drawDecoys();
  ctx.restore();
  if (!lite) host.drawDmgPopups();
  if (carry && !lite) {
    carry.blizzards = host.blizzards;
    carry.firewalls = host.firewalls;
    carry.icewalls = host.icewalls;
    carry.hellrips = host.hellrips;
    carry.particles = host.particles;
    carry.shockwaves = host.shockwaves;
    carry.beams = host.beams;
    carry.armPops = host.armPops;
    carry.spellSpritePops = host.spellSpritePops;
    carry.dmgPopups = host.dmgPopups;
    carry.meteorCraters = host.meteorCraters;
    carry.floorBurns = host.floorBurns;
    carry.meteorNukeClouds = host.meteorNukeClouds;
    carry.meteorNukeSwamps = host.meteorNukeSwamps;
    carry.meteorNukeFuses = host.meteorNukeFuses;
    carry.spriteTrails = host.spriteTrails;
    carry._trailLastPos = host._trailLastPos;
  } else if (carry) {
    carry.blizzards = host.blizzards;
    carry.firewalls = host.firewalls;
    carry.icewalls = host.icewalls;
    carry.hellrips = host.hellrips;
    carry.spriteTrails = host.spriteTrails;
    carry._trailLastPos = host._trailLastPos;
  }
};
